import React, { useEffect, useState } from 'react';

import { Button, Container, Grid, Link, makeStyles, Typography } from '@material-ui/core';
import { useHistory } from 'react-router-dom';

import useBlocRefHook from '../../utils/useBlocRef.hook';

const useStyles = makeStyles((theme) => {
  return {
    container2: {
      color: '#999999',
      fontSize: '20px',
      fontWeight: 400,
      lineHeight: '30px',
      paddingTop: '30px',
    },
    packagePopular: {
      color: theme.palette.primary.main,
      fontSize: '14px',
      fontWeight: 600,
      lineHeight: '122%',
    },
  };
});

export default () => {
  const blocRef = useBlocRefHook('downgradeBloc');
  const classes = useStyles();
  const history = useHistory();
  const [downloadProcessed, setDownloadProcessed] = useState(false);

  useEffect(() => {
    const subscription = blocRef.current.downloadProcessed$.subscribe(setDownloadProcessed);
    return () => subscription.unsubscribe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleContinue = async () => {
    await blocRef.current.continueDowngrade();
    history.push('/patient-dashboard');
  };

  const handleDownload = async () => {
    await blocRef.current.downloadUnwantedStudies();
  };

  return (
    <Grid container component={Container} justify="center" alignItems="center" style={{ display: 'flex', height: '90vh', padding: '18%', width: '100vw' }}>
      <Grid item xs={12}>
        <Typography className="page-header">Do you want to download and store any unselected files locally?</Typography>
      </Grid>
      <Grid item xs={12} className="mt-1">
        <Typography className="body-copy">
          Before continuing we will give you the opportunity to download any files you did not select to carry over to your subscription
        </Typography>
      </Grid>
      <Grid item xs={12} className="mt-1">
        <Typography className="body-copy" style={{ color: '#B12A2A' }}>
          Do note that any unselected files will be removed from our system
        </Typography>
      </Grid>
      <Grid item xs={12} className="mt-1">
        <Button color="primary" onClick={handleDownload} variant="contained" disabled={downloadProcessed}>
          Download Now
        </Button>
      </Grid>

      {downloadProcessed ? (
        <Grid item xs={12} className="mt-1">
          <Typography variant="subtitle1">You will get an email when your download is ready</Typography>
        </Grid>
      ) : null}

      <Grid item xs={12} className="mt-1">
        <Container className={classes.container2}>
          <Button onClick={handleContinue}>
            <Link className={classes.packagePopular} to="/package-plans" style={{ fontSize: '20px' }}>
              I want to continue without downloading
            </Link>
          </Button>
        </Container>
      </Grid>
    </Grid>
  );
};
